// extracted by mini-css-extract-plugin
export var labelWrapper = "_dp-0";